import React from 'react';
import './RigaKpi.css';

/**
 * La fila di tile in cima a una scheda. Su telefono sta su una riga sola, quindi le voci sono
 * cinque e le etichette corte: è il vincolo che ha deciso quali numeri meritano la fila e quali
 * stanno nel dettaglio più sotto.
 */
export default function RigaKpi({ voci }) {
  return (
    <div className="kpi-riga">
      {voci.map((v) => (
        <div className="kpi-tile" key={v.chiave}>
          <b className="kpi-valore">{v.valore ?? 0}</b>
          <span className="kpi-etichetta">{v.etichetta}</span>
        </div>
      ))}
    </div>
  );
}
